import { Col, Form, Input, Modal, notification, Row, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { buildRangeDates } from '../../utils/helper'
import { Typography } from '../../../../../core/components'
import forecast from 'modules/forecast'
import { useParams } from 'react-router-dom'
import PropTypes from 'prop-types'
import { generateMessageError } from 'modules/core/utils'

const MapperDateModal = ({
  index,
  visible,
  onClose,
  period,
  mapperDates,
  setMapperDates,
  filterDates,
  customStartDate = null,
  fetchCutDates,
  fetchForecasts,
  forecasts,
}) => {
  let { forecastId } = useParams()
  const [form] = Form.useForm()
  const { t } = useTranslation()

  const disabledMonths = forecasts?.values.find((el) => el.id === parseInt(forecastId))?.year_month

  const datesPeriod = buildRangeDates(period?.start_date, period?.end_date)

  const disableCutDates = datesPeriod.filter((el) => el <= disabledMonths)

  useEffect(() => {
    if (!period?.id) return

    const loadData = async () => {
      try {
        await Promise.all([fetchForecasts({ period_id: period.id }), fetchCutDates()])
      } catch (err) {
        notification.error({
          message: t('FEEDBACK_DEFAULT_ERROR'),
          description: generateMessageError(err),
          duration: 0,
        })
      }
    }
    loadData()
  }, [fetchCutDates, fetchForecasts, period?.id])

  useEffect(() => {
    if (visible) {
      const mapperDate = (mapperDates[index] ?? []).reduce((acc, data) => {
        acc = { ...acc, [data.date_destination]: data.date_origin }
        return acc
      }, {})
      const startDate =
        customStartDate !== null ? customStartDate.clone().add(1, 'months') : period.start_date
      const dateList = buildRangeDates(startDate, period.end_date)

      const initialValues = dateList.map((it) => {
        return {
          date_destination: it,
          date_origin: mapperDate[it] ? mapperDate[it] : '',
        }
      })

      form.setFieldsValue({ mapper_dates: initialValues })
    }
  }, [mapperDates, form, index, visible, period, customStartDate])

  const generateOptions = () => {
    const { date_start, date_end } = filterDates
    return buildRangeDates(date_start, date_end)
  }

  const onCancel = () => {
    form.resetFields()
    onClose()
  }

  const handleConfirm = () => {
    form.validateFields().then((values) => {
      setMapperDates((prevState) => {
        return { ...prevState, ...{ [index]: values.mapper_dates } }
      })
      onCancel()
    })
  }

  return (
    <Modal
      title={t('ACTION_MAPPER_SEE_FILTER')}
      visible={visible}
      onCancel={onCancel}
      okText={t('ACTION_SAVE')}
      onOk={handleConfirm}
      bodyStyle={{ overflowY: 'auto', maxHeight: 400 }}
      centered
      destroyOnClose
      forceRender
    >
      <Form form={form} layout="vertical" initialValues={{ mapper_dates: [''] }}>
        <Form.List name="mapper_dates">
          {(fields, { add, remove }) => {
            return (
              <div>
                <Row
                  gutter={24}
                  justify="end"
                  style={{ marginBottom: 10, borderBottom: '1px solid #e8e8e8' }}
                >
                  <Col span={12}>
                    <Typography.Subtitle>{t('DATE_DESTINATION')}</Typography.Subtitle>
                  </Col>
                  <Col span={12}>
                    <Typography.Subtitle>{t('DATE_ORIGIN')}</Typography.Subtitle>
                  </Col>
                </Row>
                {fields.map((field, index2) => {
                  return (
                    <Row gutter={24} key={field.key} justify="end">
                      <Col span={12}>
                        <Form.Item name={[field.name, 'date_destination']}>
                          <Input disabled={true} />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item name={[field.name, 'date_origin']}>
                          <Select
                            showArrow
                            allowClear
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            disabled={disableCutDates.includes(
                              form.getFieldValue().mapper_dates[field.key].date_destination,
                            )}
                            options={generateOptions().map((it) => {
                              return { value: it, label: it }
                            })}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  )
                })}
              </div>
            )
          }}
        </Form.List>
      </Form>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  forecasts: forecast.selectors.getForecasts(state),
})

const mapDispatchToProps = {
  fetchCutDates: forecast.actions.fetchCutDates,
  fetchForecasts: forecast.actions.fetchForecasts,
}

MapperDateModal.propTypes = {
  index: PropTypes.number,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  period: PropTypes.shape({
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    id: PropTypes.any,
  }),
  mapperDates: PropTypes.array,
  setMapperDates: PropTypes.func,
  filterDates: PropTypes.shape({
    date_start: PropTypes.string,
    date_end: PropTypes.string,
  }),
  customStartDate: PropTypes.any,
  fetchCutDates: PropTypes.func,
  fetchForecasts: PropTypes.func,
  forecasts: PropTypes.shape({
    values: PropTypes.array,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(MapperDateModal)
